// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-cell-status[data-v-58c1d65a]{display:flex;align-items:center;justify-content:flex-start;height:100%}`, "",{"version":3,"sources":["webpack://./client/components/TableCells/TableCellStatus.vue"],"names":[],"mappings":"AAGA,oCACE,YAAA,CACA,kBAAA,CACA,0BAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
